export let license = {
    "FREE": {
        licenseType: "FREE",
        editable: false,
        isWebView: false,
        cannotPublish: true,
        order: 0
    },
    "WEBVIEW": {
        licenseType: "WEBVIEW",
        isWebView: true,
        order: 1
    },
    "NATIVE_BASIC": {
        licenseType: "NATIVE_BASIC",
        draggable: false,
        order: 2
    },
    "NATIVE_PRO": {
        licenseType: "NATIVE_PRO",
        draggable: false,
        order: 3
    },
    "NATIVE_PREMIUM": {
        licenseType: "NATIVE_PREMIUM",
        draggable: true,
        order: 4
    },
    "ENTERPRISE": {
        licenseType: "ENTERPRISE",
        draggable: true,
        order: 5
    },
    "DEMO": {
        licenseType: "DEMO",
        draggable: true,
        order: 6,

    }
}

